module.exports = __webpack_public_path__ + "img/shuvaev.645c4e0e.jpg";